import { Grid, SVG, SVGs, Text } from '@raskrask-dk/rr-components'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { PropsAdditionalFieldsTemplate } from './props'
import BookingReasonsTemplate from '../../Fields/bookingReasons'
import DescriptionFieldTemplate from '../../Fields/description'
import ParkingFieldTemplate from '../../Fields/parking'
import SpecialCareFieldTemplate from '../../Fields/specialCare'
import CompanyOneOffExtraInfoTemplate from '../../Fields/companyOneOffExtraInfo'
import { InfoBox } from './styles'

const AdditionalFieldsTemplate = ({
    bookingReasonHandler,
    descriptionHandler,
    parkingHandler,
    specialCareHandler,
    customerType,
    goalId,
}: PropsAdditionalFieldsTemplate): ReactElement => {
    const { i18n, t } = useTranslation()

    const [description, setDescription, canSetDescription] = descriptionHandler
    const [
        selectedBookingReasons,
        bookingReasons,
        onClickBookingReason,
        canSetBookingReasons,
    ] = bookingReasonHandler
    const [parking, setParking, canSetParking] = parkingHandler
    const [specialCare, setSpecialCare, canSetSpecialCare] = specialCareHandler

    const isCompany = customerType === 'Company'
    const hasGoalInfo = i18n.exists(`details.form.goalinfo.${goalId}`)
    const shouldShowTitle =
        (canSetBookingReasons || canSetDescription || canSetParking) &&
        !isCompany

    return (
        <>
            {(shouldShowTitle || canSetBookingReasons) && (
                <Grid gap={4}>
                    {hasGoalInfo && (
                        <InfoBox>
                            <SVG css={{ m: '$1 0' }} src={SVGs.Exclamation} />
                            <Text bold>
                                {t(`details.form.goalinfo.${goalId}`)}
                            </Text>
                        </InfoBox>
                    )}
                    {shouldShowTitle && (
                        <Text
                            size={{ '@desktop': 'xl' }}
                            bold={{ '@desktop': true }}
                            primary={{ '@desktop': true }}
                        >
                            {t('details.form.healthproblems.header')}
                        </Text>
                    )}
                    {canSetBookingReasons && (
                        <BookingReasonsTemplate
                            bookingReasons={bookingReasons}
                            selectedBookingReasons={selectedBookingReasons}
                            onClickBookingReason={onClickBookingReason}
                        />
                    )}
                </Grid>
            )}
            {isCompany && <CompanyOneOffExtraInfoTemplate />}
            {canSetDescription && (
                <DescriptionFieldTemplate
                    description={description}
                    setDescription={setDescription}
                />
            )}
            {canSetParking && isCompany && (
                <Text css={{ fontSize: 'medium' }} bold>
                    {t('details.form.parking.header')}
                </Text>
            )}
            {canSetParking && (
                <ParkingFieldTemplate
                    parking={parking}
                    setParking={setParking}
                />
            )}
            {canSetSpecialCare && (
                <SpecialCareFieldTemplate
                    specialCare={specialCare}
                    setSpecialCare={setSpecialCare}
                />
            )}
        </>
    )
}
// Parkeringstext overskrift
export default AdditionalFieldsTemplate
